var h = Object.defineProperty;
var a = (s, e, t) => e in s ? h(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var c = (s, e, t) => a(s, typeof e != "symbol" ? e + "" : e, t);
import { clsx as r } from "clsx";
import { twMerge as n } from "tailwind-merge";
function m(...s) {
  return n(r(s));
}
class l {
  constructor(e = 100) {
    c(this, "cache", /* @__PURE__ */ new Map());
    c(this, "maxSize");
    this.maxSize = e;
  }
  get(e) {
    const t = this.cache.get(e);
    return t !== void 0 && (this.cache.delete(e), this.cache.set(e, t)), t;
  }
  set(e, t) {
    if (this.cache.has(e))
      this.cache.delete(e);
    else if (this.cache.size >= this.maxSize) {
      const i = this.cache.keys().next().value;
      i !== void 0 && this.cache.delete(i);
    }
    this.cache.set(e, t);
  }
  has(e) {
    return this.cache.has(e);
  }
  get size() {
    return this.cache.size;
  }
}
function d(s, e) {
  return e.some((t) => t.startsWith(".") ? s.name.toLowerCase().endsWith(t.toLowerCase()) : s.type.startsWith(t));
}
export {
  l as LRUCache,
  m as cn,
  d as fileMatchesAccept
};
